// IMPORTS
import resultsStyles from "../../../css/results.scss";
import { computed, onMounted, ref } from 'vue'
import navButton from "./buttons/navButton";
import { storeResults } from "../store/storeResults";
import resultsCard from "./resultsCard";

/**
 * Exporting "default" so that the import doesn't have to be named in other components.
 * To create named and/or multiple exports, use: export cont compName = {}
 * Remember to import any reactive features from 'vue' if you need reactivity (e.g. computed, ref, reactive, etc.)
 */
export default {
    /* Name the component for easy reference */
    name: 'ResultsBox',

    /* Any imported component for this file needs to be listed here */
    components: {
        navButton,
        resultsCard
    },

    /* Declare any expected props here */
    props: {
        sampleProp: {
            type: String,
            required: false,
            default: ''
        }
    },

    /* All component logic goes here in setup(). Anything complex or verbose should be handled in an external file,
        using this as more of a "controller" for the component.
    */
    setup(props) {
        onMounted(async () => {
            const eventID = storeResults.state.getEventID();
            const widgetID = storeResults.state.getWidgetID();
            const refreshInterval = 300000 // 5 minutes

            // GET INITIAL RESULTS
            getEcResults(eventID, widgetID);

            // SET INTERVAL FOR UPDATING THE RESULTS
            let ecInt = setInterval(() => {
                getEcResults(eventID, widgetID);
            }, refreshInterval);

            /* const ecResults = await storeResults.fetchResults(eventID, widgetID);

            console.log('ecResults: ', ecResults.races);

            storeResults.state.setEcResults(ecResults.races); */
        });

        async function getEcResults(eventID, widgetID) {
            const ecResults = await storeResults.fetchResults(eventID, widgetID);

            console.log('ecResults: ', ecResults.races);

            storeResults.state.setEcResults(ecResults.races);
        }

        const ballotIndex = ref(0);

        const results = computed(() => {
            return storeResults.state.getEcResults();
        });

        function finalLabel(resultRow) {
            let label = resultRow.name;

            if(typeof resultRow.name_override != 'undefined') {
                label = resultRow.name_override;
            }

            return label;
        };

        const changeCardIndex = (dir) => {
            switch(dir) {
                case 'prev':
                    if(typeof results.value[ballotIndex.value - 1] != 'undefined') {
                        ballotIndex.value = ballotIndex.value - 1;
                    }
                    else {
                        ballotIndex.value = results.value.length - 1;
                    }
                    break;

                case 'next':
                    if(results.value[ballotIndex.value + 1]) {
                        ballotIndex.value = ballotIndex.value + 1;
                    }
                    else {
                        ballotIndex.value = 0;
                    }
                    break;
            }
        }

        /* We need to return any variables/functions that we want to use in our template below. */
        return {
            props,
            results,
            ballotIndex,
            changeCardIndex,
            finalLabel
        }
    },

    /* Define the template that will be displayed for this component (optional) */
    template: /*html*/`
        <div class="cfm_ec_results_box"
        v-if="results.length > 0"
        >

            <div class="cfm_ec_results_nav_container"
            @click.stop="changeCardIndex('prev')"
            >
                <nav-button direction="left"></nav-button>
            </div>

            <div class="results_box_content">

                <results-card
                :label="finalLabel(results[ballotIndex])"
                :description="results[ballotIndex].description"
                :candidates="results[ballotIndex].candidates"
                :raceType="results[ballotIndex].raceType"
                ></results-card>

            </div>

            <div class="cfm_ec_results_nav_container"
            @click.stop="changeCardIndex('next')"
            >
                <nav-button direction="right"></nav-button>
            </div>

        </div>
    `,
}